/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertTenantPlatformStoragePolicyRequest
 */
export interface UpsertTenantPlatformStoragePolicyRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpsertTenantPlatformStoragePolicyRequest
     */
    optedIn?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpsertTenantPlatformStoragePolicyRequest
     */
    retentionDays?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertTenantPlatformStoragePolicyRequest
     */
    billingAttestationAccepted?: boolean;
}

/**
 * Check if a given object implements the UpsertTenantPlatformStoragePolicyRequest interface.
 */
export function instanceOfUpsertTenantPlatformStoragePolicyRequest(value: object): value is UpsertTenantPlatformStoragePolicyRequest {
    return true;
}

export function UpsertTenantPlatformStoragePolicyRequestFromJSON(json: any): UpsertTenantPlatformStoragePolicyRequest {
    return UpsertTenantPlatformStoragePolicyRequestFromJSONTyped(json, false);
}

export function UpsertTenantPlatformStoragePolicyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertTenantPlatformStoragePolicyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'optedIn': json['optedIn'] == null ? undefined : json['optedIn'],
        'retentionDays': json['retentionDays'] == null ? undefined : json['retentionDays'],
        'billingAttestationAccepted': json['billingAttestationAccepted'] == null ? undefined : json['billingAttestationAccepted'],
    };
}

export function UpsertTenantPlatformStoragePolicyRequestToJSON(json: any): UpsertTenantPlatformStoragePolicyRequest {
    return UpsertTenantPlatformStoragePolicyRequestToJSONTyped(json, false);
}

export function UpsertTenantPlatformStoragePolicyRequestToJSONTyped(value?: UpsertTenantPlatformStoragePolicyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'optedIn': value['optedIn'],
        'retentionDays': value['retentionDays'],
        'billingAttestationAccepted': value['billingAttestationAccepted'],
    };
}

